let sexCateg = {
	title: "Секс",
	categs: [
		"Секс классический",
		"Секс анальный",
		"Секс групповой",
		"Секс лесбийский",
		"Семейной паре",
		"Минет в резинке",
		"Минет без резинки",
		"Минет глубокий",
		"Минет горловой",
		"Минет в машине",
		"Куннилингус",
		"Целуюсь",
		"Игрушки",
		"Окончание на грудь",
		"Окончание на лицо",
		"Окончание в рот",
		"Поза 69"
	]
}
let	massageCateg = {
	title: "Массаж",
	categs: [
		"Массаж классический",
		"Массаж профессиональный",
		"Массаж расслабляющий",
		"Массаж урологический",
		"Массаж эротический",
		"Массаж семейной паре",
		]
}

let	extremeCateg = {
	title: "Экстрим",
	categs: [
		"Страпон",
		"Анилингус клиенту",
		"Анилингус мне",
		"Золотой дождь клиенту",
		"Золотой дождь мне",
		"Фистинг анальный клиенту",
		"Фистинг анальный мне",
		"Фистинг классический",
		"Фингеринг"
		]
}
let	sadomazoCateg = {
	title: "Садо-мазо",
	categs: [
		"Госпожа",
		"Доминирование",
		"Рабыня",
		"Подчинение",
		"Бондаж",
		"Порка",
		"Фетиш",
		"Трамплинг",
		"Шибари",
		"Фейсситтинг",
		"Копро (выдача)",
		"Копро (прием)",
		"Сквирт"
		]
}
let	stripCateg = {
	title: "Стриптиз",
	categs: [
		"Стриптиз профи",
		"Стриптиз не профи",
		"Лесби откровенное",
		"Лесби-шоу легкое"
		]
}
let	otherCateg = {
	title: "Разное",
	categs: [
		"GFE",
		"Сопровождение",
		"Ролевые игры",
		"Фото/видео съемка",
		"Виртуальный секс",
		"Cекс по телефону",
		"Готова к поездкам в другой город",
		"Есть шенген",
		"Есть загранпаспорт",
		"Клизма",
		"Пип-шоу",
		"Танец живота"
		]
}
export default [sexCateg, massageCateg, extremeCateg, sadomazoCateg, stripCateg, otherCateg];